import PropTypes from 'prop-types';
import React from 'react';
export var DisclaimerModal = function DisclaimerModal(props) {
  return React.createElement("div", {
    className: "disclaimer-modal"
  }, React.createElement("span", {
    className: "disclaimer-modal__close",
    onClick: props.onClose
  }, "x"), props.text);
};
DisclaimerModal.propTypes = {
  text: PropTypes.element.isRequired,
  onClose: PropTypes.func
};